import { useNavigate } from "react-router";

import './help.scss'

export function Help() {
  const navigate = useNavigate()

  return <div className="help">
    <div className="row">
      <div className="col">
        <h1>Help</h1>
        <p>
          Email us at&nbsp;
          <a href="mailto:support@healthsharetech.freshdesk.com">
            support@healthsharetech.freshdesk.com
          </a>
        </p>
        <p className="mt-4">
          Missed something the first time?
          &nbsp;
          <a className="btn btn-info"
            onClick={() => {
              localStorage.setItem('startTour', 'true')
              setTimeout(() => {
                navigate('/')
              }, 1)
            }}
            >Take the tour again</a>
        </p>
      </div>
    </div>
  </div>
}
